import { useEffect, useRef } from 'react'
import { toast } from 'sonner'
import { runSummaryText, type TranslationRunView } from '@/features/ai/lib/translationRun'

/**
 * Тост итога — только на ЖИВОМ переходе «идёт → закончен». Запись реестра
 * лежит в persist: после перезагрузки первое, что видит хук, — уже
 * законченный прогон (или «неизвестно»), и тост всплыл бы повторно через день.
 *
 * «Идёт» переживает промежуточное «неизвестно»: на стыке цепочки «текст →
 * картинки» опрос на миг теряет ответ, и без этого переход «идёт → закончен»
 * рвался бы надвое — особенно на отмене, где картиночная джоба при первом же
 * чтении уже `cancelled`. Перезагрузку это не задевает: там «идёт» до
 * «неизвестно» никто не видел.
 *
 * Эффект ключуется примитивами, а не объектом вида: `translationRunView`
 * строит новый объект на каждом рендере.
 *
 * `silent` — итог уже виден плашкой в открытой шторке: тост её только дублировал бы.
 */
export const useRunFinishedToast = (view: TranslationRunView, silent = false): void => {
  const previous = useRef(view.kind)
  const jobId = view.kind === 'running' || view.kind === 'finished' ? view.jobId : null
  const status = view.kind === 'finished' ? view.status : null
  const text = view.kind === 'finished' ? runSummaryText(view.status, view.textDone) : null
  const kind = view.kind
  useEffect(() => {
    const was = previous.current
    if (!(was === 'running' && kind === 'unknown')) previous.current = kind
    if (was !== 'running' || kind !== 'finished' || !text || silent) return
    if (status === 'success') toast.success(text)
    else if (status === 'cancelled') toast(text)
    else toast.error(text)
  }, [kind, jobId, status, text, silent])
}
